import React, { useContext, useState } from "react";
import { Box, Button, Paper, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Tooltip } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import Application from "../../../components/application";
import MyPanel from "../../../components/myPanel";
import MyLabel from "../../../components/myLabel";
import MyInput from "../../../components/myInput";
import MyButton from "../../../components/myButton";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import MyLoading from "../../../components/myLoading";
import useLocalTarefaFormulario from "../../../hooks/useLocalTarefaFormulario";
import MySearch from "../../../components/mySearch";
import DeleteIcon from '@mui/icons-material/Delete';
import Styles from "./style";
import MyCheckbox from "../../../components/myCheckbox";
import MapModal from "./mapModal";
import MyImage from "../../../components/myImage";
import TELAS from "../../../constants/telas";
import { AuthContext } from "../../../contexts/auth";

import TELA_ACOES from "../../../constants/telaAcoes";
import permissaoTelas from "../../../utils/permissaoTelas";
import { Margin } from "@mui/icons-material";


const PAGINA = {
    aplicacao: 'SisPalo - Tarefas',
    funcionalidade: 'Tarefas',
    tela: TELAS.LOCAIS_DE_TAREFAS,
    acoes: [TELA_ACOES.Incluir, TELA_ACOES.Alterar]
}

const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {
            value === index ?
                children
            :   
                <></>
        }
      </div>
    );
  }
  
const a11yProps = (index)  =>{
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
}

const TabArea = ({label, registros, registrosSelecionadas, styles, maximoSelecionados}) => {

    const handlerRemove = (id) => {
            let _permi = registrosSelecionadas.value.filter(item => item.id !== id)
            registrosSelecionadas.set(_permi)
    }

    return (
        <Box sx={{marginTop:'20px'}}>
            <MySearch 
                getOptions = {registros.set}

                label={label}
                values={registros.value}
                valuesSelects={registrosSelecionadas.value}
                onSelect={(select)=>{
                    if (registrosSelecionadas.value.filter(e => e.name === select.name).length <= 0) {
                        registrosSelecionadas.set([...registrosSelecionadas.value, select])
                    }
                }} 
                maximoSelecionados = {maximoSelecionados}
                />
            <Box sx={{marginTop: '10px'}}>
                <Box >
                    <MyLabel sx={styles.subtitle} text={`Selecionados(as)`} component={null}  onClick={null} variant={null}/>
                </Box>
                <Box>
                    <TableContainer component={Paper} sx={{maxHeight:'25vh'}}>
                        <Table size="small"  sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead >
                            <TableRow >
                                <TableCell sx={styles.tableHead}> Nome</TableCell>
                                <TableCell sx={styles.tableHead}> </TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            {registrosSelecionadas.value.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1).map((row, key) => (
                                <TableRow
                                    
                                    key={key}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                <TableCell component="th" scope="row" >
                                    {row.name}
                                </TableCell>
                                <TableCell sx={{width:'20px'}} component="th" scope="row" >
                                    <Tooltip title="Remover" placement="bottom" arrow>
                                        <Button sx={{height:'20px'}} color='error'  onClick={()=>handlerRemove(row.id)}><DeleteIcon /></Button>
                                    </Tooltip> 
                                </TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </Box>
    )
}

const LocalTarefaFormulario = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    
    const states = useLocalTarefaFormulario()
    const [activeTab, ssetActiveTab] = useState(0);
    const {permissaoUsuario, user} = useContext(AuthContext); /* permissão para telas*/    

    let styles = Styles()    
    
    const handleChange = (event, newValue) => {
        ssetActiveTab(newValue);
    };    

    useEffect(()=>{
        if (permissaoTelas(permissaoUsuario, TELA_ACOES.Incluir, PAGINA)
            || permissaoTelas(permissaoUsuario, TELA_ACOES.Alterar, PAGINA)){
            if (id && id !== ''){
                states.submit.set(id)
            }
        }
        else {
            navigate('/gestor/dashboard')
        }

    }, [])

    

    let minhasTabs = [
        {label:'Selecione posto',  registros: states.postos, registrosSelecionadas: states.postosSelecionados, maximoSelecionados:1},
    ]    

    let tabsTarefas = [
        {label:'Tarefas Permitidas',  registros: states.tarefas, registrosSelecionadas: states.tarefasSelecionadas, maximoSelecionados:null},
    ]    
    return (
   
        <Application>
            <MyPanel>
                <MyLoading render={states.submit.value}/>
                <Stack spacing={3}>
                    <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
                        <MyLabel sx={{width:'80%'}} component='p' text = {`Local da Tarefa: ${id ? states.local.value.nome : ''}`} />                                
                        { user.value.is_staff ?
                            <MyCheckbox
                                sx={{width:'10%'}}
                                label='Editável'
                                disabled={false}
                                checked={states.local.value?.editavel}
                                onChange={()=> {
                                    let _local = {...states.local.value}
                                    _local.editavel = !_local.editavel
                                    states.local.set(_local)
                                }}
                            />                            
                        :
                            <></>
                         }
                        <Box sx={{ width:'10%', display:'flex', justifyContent:'flex-end', aligItems:'center'}}> {/* imagem do Qrcode */}
                            {states.qrcode.value && states.local.value?.editavel ? 
                                <MyImage sx={{height:'80px', width:'80px', marginLeft:'10px'}} src={states.qrcode.value} alt="QR Code"/>
                                : 
                                <Box sx={{height:'80px', width:'80px'}}/>
                            }                    
                        </Box>
                    </Box>
                    <Box sx={{display:'flex', justifyContent:'space-between'}}>
                        <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%'}}>
                            <MyInput sx={{width:'100%', marginRight:1}} size="small" label='Nome do Local' type='text' 
                                value={states.local.value?.nome} 
                                onChange={(e)=>{
                                    let _local = {...states.local.value}
                                    _local.nome = e.target.value
                                    states.local.set(_local)
                                }}                        
                            />
                            <MyInput sx={{marginRight:1}} size="small" label='Integração' type='text' 
                                    value={states.local.value?.integracao} 
                                    onChange={(e)=>{
                                        let _local = {...states.local.value}
                                        _local.integracao = e.target.value
                                        states.local.set(_local)
                                    }}                        
                                />

                            <MyCheckbox
                                label='Ativo'
                                disabled={false}
                                checked={states.local.value?.ativo}
                                onChange={()=> {
                                    let _local = {...states.local.value}
                                    _local.ativo = !_local.ativo
                                    states.local.set(_local)
                                }}
                            />                            
                        </Box>
                    </Box>
                    <Box>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={activeTab} onChange={handleChange} aria-label="basic tabs example">
                                {
                                    minhasTabs.map((item, key) => <Tab key={key} label={item.label} {...a11yProps(key)} />)
                                }
                            </Tabs>
                        </Box>
                            {
                                minhasTabs.map((item, key)=>{
                                    return (
                                        <CustomTabPanel key={key} value={activeTab} index={key}>
                                            <TabArea 
                                                label={item.label}
                                                registros={item.registros}
                                                registrosSelecionadas={item.registrosSelecionadas}
                                                styles={styles}
                                                maximoSelecionados = {item.maximoSelecionados}
                                            />
                                        </CustomTabPanel>

                                    )
                                })

                            }
                    </Box>

                    
                    <Box sx={{
                        display:'flex', 
                        marginTop: 2 , 
                        justifyContent:'space-between', 
                        '@media (max-width: 800px)':{
                            flexDirection:'column'
                        }
                        }}>
                        <Box sx={{marginRight:'25px', display:'flex', flexDirection:'column'}}>
                            <Box sx={{marginTop:'25px', borderBottom: 1, borderColor: 'divider' }}>
                                <MyLabel component='p' text = {`Endereço do local onde sera realizado a Tarefa`} />
                            </Box>

                            <Box sx={{display:'flex', marginTop:'15px'}}>
                                <Box sx={{display:'flex'}}>

                                    <MyInput sx={{width:'180px', marginRight:'10px'}} size="small" label='CEP' type='text' value={states.enderecoLocal.value?.cep} 
                                        onChange={(e)=>{
                                            if (/^\d+$/.test(e.target.value) || e.target.value === ''){
                                                let _enderecoLocal = {...states.enderecoLocal.value}
                                                _enderecoLocal.cep = e.target.value
                                                states.enderecoLocal.set(_enderecoLocal)
                                            }
                                        }}
                                    />
                                    <SearchIcon onClick={states.cep.set} />
                                </Box>
                                <MyInput disabled={true} sx={{width:'180px', marginRight:'10px'}} size="small" label='Tipo Log.' type='text' value={states.enderecoLocal.value?.tipo} 
                                    onChange={(e)=>{
                                        let _enderecoLocal = {...states.enderecoLocal.value}
                                        _enderecoLocal.tipo = e.target.value
                                        states.enderecoLocal.set(_enderecoLocal)
                                    }}
                                />
                                <MyInput disabled={true} sx={{width:'100%', marginRight:'10px'}} size="small" label='Logradouro' type='text' value={states.enderecoLocal.value?.logradouro} 
                                    onChange={(e)=>{
                                        let _enderecoLocal = {...states.enderecoLocal.value}
                                        _enderecoLocal.logradouro = e.target.value
                                        states.enderecoLocal.set(_enderecoLocal)
                                    }}
                                />
                            </Box>
                            <Box sx={{display:'flex', marginTop:'15px'}}>
                                <MyInput sx={{width:'300px', marginRight:'20px'}} size="small" label='Número' type='text' value={states.enderecoLocal.value?.numero} 
                                    onChange={(e)=>{
                                        let _enderecoLocal = {...states.enderecoLocal.value}
                                        _enderecoLocal.numero = e.target.value
                                        states.enderecoLocal.set(_enderecoLocal)
                                    }}
                                />
                                <MyInput sx={{width:'100%', marginRight:'10px'}} size="small" label='Complemento' type='text' value={states.enderecoLocal.value?.complemento} 
                                    onChange={(e)=>{
                                        let _enderecoLocal = {...states.enderecoLocal.value}
                                        _enderecoLocal.complemento = e.target.value
                                        states.enderecoLocal.set(_enderecoLocal)
                                    }}
                                />
                                <MyInput disabled={true} sx={{width:'100%', marginRight:'10px'}} size="small" label='Bairro' type='text' value={states.enderecoLocal.value?.bairro} 
                                    onChange={(e)=>{
                                        let _enderecoLocal = {...states.enderecoLocal.value}
                                        _enderecoLocal.bairro = e.target.value
                                        states.enderecoLocal.set(_enderecoLocal)
                                    }}
                                />
                                <MyInput disabled={true} sx={{width:'100%', marginRight:'10px'}} size="small" label='Cidade' type='text' value={states.enderecoLocal.value?.cidade} 
                                    onChange={(e)=>{
                                        let _enderecoLocal = {...states.enderecoLocal.value}
                                        _enderecoLocal.bairro = e.target.value
                                        states.enderecoLocal.set(_enderecoLocal)
                                    }}
                                />
                                <MyInput disabled={true} sx={{width:'200px', marginRight:'10px'}} size="small" label='UF' type='text' value={states.enderecoLocal.value?.uf} 
                                    onChange={(e)=>{
                                        let _enderecoLocal = {...states.enderecoLocal.value}
                                        _enderecoLocal.uf = e.target.value
                                        states.enderecoLocal.set(_enderecoLocal)
                                    }}
                                />
                            </Box>
                        
                        </Box>
                        <Box sx={{marginRight:'10px'}} >
                            <Box sx={{marginTop:'25px', borderBottom: 1, borderColor: 'divider' }}>
                                <MyLabel component='p' text = {`Cerca permitida no local onde será realizado a Tarefa`}/>
                            </Box>
                            <Box sx={{display:'flex',marginTop:'15px'}}>
                                <MapModal  latitude={states.cercaLocal.value?.latitude}  longitude={states.cercaLocal.value?.longitude}/>
                                <MyInput disabled={!states.cercaLocal.value?.coordenada_manual} sx={{width:'180px', marginRight:'10px'}} size="small" label='Latitude'  type='text' value={states.cercaLocal.value?.latitude} 
                                    onChange={(e)=>{
                                        let _cercaLocal = {...states.cercaLocal.value}
                                        _cercaLocal.latitude = e.target.value
                                        states.cercaLocal.set(_cercaLocal)
                                    }}
                                />
                                <MyInput disabled={!states.cercaLocal.value?.coordenada_manual} sx={{width:'180px', marginRight:'10px'}} size="small" label='Longitude'  type='text' value={states.cercaLocal.value?.longitude} 
                                    onChange={(e)=>{
                                        let _cercaLocal = {...states.cercaLocal.value}
                                        _cercaLocal.longitude = e.target.value
                                        states.cercaLocal.set(_cercaLocal)
                                    }}
                                />
                                <MyCheckbox
                                    label='Editar'
                                    checked={states.cercaLocal.value?.coordenada_manual}
                                    onChange={()=> {
                                        let _cercaLocal = {...states.cercaLocal.value}
                                        _cercaLocal.coordenada_manual = !_cercaLocal.coordenada_manual
                                        if(!_cercaLocal.coordenada_manual){ 
                                            states.cep.set()
                                        }
                                        states.cercaLocal.set(_cercaLocal)
                                    }}
                                />                                
                            </Box>
                            <Box sx={{display:'flex',marginTop:'15px', marginLeft:'23px'}}>
                                <MyInput sx={{width:'180px', marginRight:'10px'}} size="small" label='Distancia'  type='text' value={states.cercaLocal.value?.distancia_permitida} 
                                    onChange={(e)=>{
                                        let _cercaLocal = {...states.cercaLocal.value}
                                        _cercaLocal.distancia_permitida = e.target.value
                                        states.cercaLocal.set(_cercaLocal)
                                    }}
                                />
                                <MyCheckbox
                                    label='Distância Indefinida'
                                    checked={states.cercaLocal.value?.distancia_indefinida}
                                    onChange={()=> {
                                        let _cercaLocal = {...states.cercaLocal.value}
                                        _cercaLocal.distancia_indefinida = !_cercaLocal.distancia_indefinida
                                        states.cercaLocal.set(_cercaLocal)
                                    }}
                                />                                
                            </Box>

                        </Box> 
                    </Box>

                    <Box sx={{display:'flex', marginTop: 2 , justifyContent:'space-between'}}>
                        <Box  sx={{width:'100%', marginRight:'30px'}}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={activeTab} onChange={handleChange} aria-label="basic tabs example">
                                    {
                                        tabsTarefas.map((item, key) => <Tab key={key} label={item.label} {...a11yProps(key)} />)
                                    }
                                </Tabs>
                            </Box>
                                {
                                    tabsTarefas.map((item, key)=>{
                                        return (
                                            <CustomTabPanel key={key} value={activeTab} index={key}>
                                                <TabArea 
                                                    label={item.label}
                                                    registros={item.registros}
                                                    registrosSelecionadas={item.registrosSelecionadas}
                                                    styles={styles}
                                                    maximoSelecionados = {item.maximoSelecionados}
                                                />
                                            </CustomTabPanel>

                                        )
                                    })

                                }
                        </Box>
                    </Box>
                    <Box sx={{display:'flex', marginTop: 2 , justifyContent:'space-between'}}>
                        <MyButton color='warning' onClick={()=> navigate('/gestor/localtarefa')} variant='contained' text='Cancelar'/>
                        <MyButton sx={{marginRight:1}} color='success' 
                        onClick={()=> states.local?.value.id ? states.localFormularioPostPut.set() : states.localFormularioPostPut.set()} 
                        variant='contained' 
                        text={states.Local?.value.nome ? 'Alterar' : 'Salvar'} />
                    </Box>
                    
                </Stack>
            </MyPanel>
        </Application>
   
    )
}

export default LocalTarefaFormulario;